"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SkeletonRow = exports.SkeletonRectangle = exports.SkeletonCircle = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _react = require("@emotion/react");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const shimmerBg = '#ccc';
const pulse = (0, _react.keyframes)`
  0% { opacity: 0.6; }
  50%  { opacity: 0.2; }
  100% { opacity: 0.6; }
`;
const defaultShimmer = /*#__PURE__*/(0, _base.default)("span", process.env.NODE_ENV === "production" ? {
  target: "enirjj93"
} : {
  target: "enirjj93",
  label: "defaultShimmer"
})("display:inline-block;position:relative;overflow:hidden;vertical-align:middle;background-color:", shimmerBg, ";animation:", pulse, " 2s infinite;");
const SkeletonRow = exports.SkeletonRow = /*#__PURE__*/(0, _base.default)(defaultShimmer, process.env.NODE_ENV === "production" ? {
  target: "enirjj92"
} : {
  target: "enirjj92",
  label: "SkeletonRow"
})("height:", props => props.height ? props.height : '1em', ";width:", props => props.width ? props.width : '65%', ";");
const SkeletonCircle = exports.SkeletonCircle = /*#__PURE__*/(0, _base.default)(defaultShimmer, process.env.NODE_ENV === "production" ? {
  target: "enirjj91"
} : {
  target: "enirjj91",
  label: "SkeletonCircle"
})("height:", props => props.height ? props.height : '34px', ";width:", props => props.width ? props.width : '34px', ";border-radius:50%;");
const SkeletonRectangle = exports.SkeletonRectangle = /*#__PURE__*/(0, _base.default)(defaultShimmer, process.env.NODE_ENV === "production" ? {
  target: "enirjj90"
} : {
  target: "enirjj90",
  label: "SkeletonRectangle"
})("height:", props => props.height ? props.height : '34px', ";width:", props => props.width ? props.width : '34px', ";border-radius:", props => props.borderRadius ? props.borderRadius : '0', ";");